module.exports = "/_next/static/images/Backup@3x-06d29756c59d174872a27905bd37c2a4.png";